const API_BASE = '/api/brand-kits';

    async function handleResponse(response) {
      console.log(`[BrandKitsAPI] Response: ${response.status} ${response.url}`);
      let body;
      try {
        body = await response.json();
      } catch (e) {
        console.error('[BrandKitsAPI] Failed to parse JSON response body:', e);
        console.error('[BrandKitsAPI] Raw response could not be parsed as JSON.');
        throw new Error(`Invalid JSON response from brand-kits API (status ${response.status}).`);
      }

      console.log('[BrandKitsAPI] Response body:', body);

      if (!response.ok) {
        const msg = body?.error || body?.message || `Request failed with status ${response.status}`;
        console.error('[BrandKitsAPI] Request failed:', {
          status: response.status,
          url: response.url,
          message: msg,
          body,
          online: typeof navigator !== 'undefined' ? navigator.onLine : undefined,
        });
        if (typeof msg === 'string' && msg.includes('Missing server env')) {
          console.error('[BrandKitsAPI] Hint: This usually means some Cloudflare environment variables (NCB_BASE_URL, NCB_INSTANCE, NCB_API_KEY) are missing or misconfigured.');
        }
        throw new Error(msg);
      }

      if (body?.status === 'error' || body?.status === 'failed') {
        const msg = body?.message || body?.error || 'API returned an error while loading brand kits.';
        console.error('[BrandKitsAPI] API reported error:', {
          statusField: body?.status,
          message: msg,
          body,
        });
        if (typeof msg === 'string' && msg.includes('Missing server env')) {
          console.error('[BrandKitsAPI] Hint: This usually indicates that NCB_BASE_URL, NCB_INSTANCE, or NCB_API_KEY are not set correctly in Cloudflare Pages.');
        }
        throw new Error(msg);
      }
      return body?.data;
    }

    export const brandKitsApi = {
      async list() {
        try {
          console.log('[BrandKitsAPI] Listing brand kits');
          const response = await fetch(API_BASE, { method: 'GET' });
          return await handleResponse(response);
        } catch (error) {
          console.error('[BrandKitsAPI] Failed to list brand kits:', error);
          throw error;
        }
      },

      async get(id) {
        try {
          console.log(`[BrandKitsAPI] Getting brand kit ${id}`);
          const response = await fetch(`${API_BASE}/${id}`);
          return await handleResponse(response);
        } catch (error) {
          console.error(`[BrandKitsAPI] Failed to get brand kit ${id}:`, error);
          throw error;
        }
      },

      async create(brandKitData) {
        try {
          console.log('[BrandKitsAPI] Creating brand kit:', brandKitData);
          const response = await fetch(API_BASE, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(brandKitData),
          });
          const responseData = await handleResponse(response);
          // Return the original data with the new ID for optimistic update
          return { ...brandKitData, id: responseData.id };
        } catch (error) {
          console.error('[BrandKitsAPI] Failed to create brand kit:', error);
          throw error;
        }
      },

      async update(id, updates) {
        try {
          console.log(`[BrandKitsAPI] Updating brand kit ${id}:`, updates);
          await fetch(`${API_BASE}/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(updates),
          });
          // Return the updates for optimistic UI update
          return { ...updates, id };
        } catch (error) {
          console.error(`[BrandKitsAPI] Failed to update brand kit ${id}:`, error);
          throw error;
        }
      },

      async delete(id) {
        try {
          console.log(`[BrandKitsAPI] Deleting brand kit ${id}`);
          const response = await fetch(`${API_BASE}/${id}`, {
            method: 'DELETE',
          });
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: 'An unknown error occurred' }));
            console.error(`[BrandKitsAPI] Delete failed:`, errorData);
            throw new Error(errorData.error || `Request failed with status ${response.status}`);
          }
          const data = await response.json();
          if (data.status === 'error') {
            console.error(`[BrandKitsAPI] Delete API error:`, data.message);
            throw new Error(data.message || 'API returned an error');
          }
          return true;
        } catch (error) {
          console.error(`[BrandKitsAPI] Failed to delete brand kit ${id}:`, error);
          throw error;
        }
      },
    };